var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "84px",
    viewBox: "0 0 70 84",
    enableBackground: "new 0 0 70 84",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 70,
    height: 84,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABUAgMAAABCXqmHAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JQAAgIMAAPn/AACA6QAAdTAAAOpgAAA6mAAAF2+SX8VGAAAACVBMVEX///8yXon///8gL6Hy AAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAJcEhZcwAALiMAAC4jAXilP3YAAAAHdElNRQfl Cg4UHQW0G9w8AAAAJ0lEQVQ4y2NgGAX4gGgoEgjAJSS2CgmMCo0KjQoNNiHiMvIoIAEAAIOgq5I6 i1g/AAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTEwLTE0VDE3OjI5OjA1KzAzOjAwKcxL3AAAACV0 RVh0ZGF0ZTptb2RpZnkAMjAyMS0xMC0xNFQxNzoyOTowNSswMzowMFiR82AAAAAASUVORK5CYII="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.babbae8107696aff60a1cd7e15b3a002.svg";
export { ForwardRef as ReactComponent };